import React, { useState } from 'react'
import "./mspSubscriptionAccounts.scss"
import { useAuth } from '../../context/Auth';
import { getAPIData } from '../../../Utils/commonApi';
import moment from "moment"
import ChipsInformativeIcon from '../../icons/chips-informatve.icon';
import TemporarySupportAccess from './temporary-support-access.component';
import Loader from "../../Common/loader";

const MspSupportAccess = ({accountId, sessionList, activeSession, refreshTempAccessList, isTempAccessLoading}) => {
  const { authTokens } = useAuth();
  const [dataLoading, setDataLoading] = useState();

  function revokeAccess(_id) {
    setDataLoading(true);
    return new Promise((resolve, reject) => {
      getAPIData(`${1101}`, authTokens, {
        optionEnum1:_id,
        optionEnum98:accountId

      }, "CC_API")
        .then((response) => {
          resolve(response);
          refreshTempAccessList()
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          setDataLoading(false);
        })
    });
  }
  return (
    <div className="support-access-container mt-4 support-access-wrapper">
      {isTempAccessLoading || dataLoading ? (
        <div className="d-flex align-items-center justify-content-center py-4 h-100">
          <Loader />
        </div>
      ) : (
        <>
          <div>
            <div className="f-16 f-600 mb-3">Temporary Support Access</div>
            {activeSession ? (
              <TemporarySupportAccess 
                session={activeSession} 
                variant='none' 
                customerId={accountId}
                refreshTempAccessList={refreshTempAccessList} 
              />
            ) : (
              <div className='bg-grey radius-8 p-3 not-granted-temp-access'>
                <h3 className='title mb-0'>
                  Support is not granted
                </h3>
                <p className='subtitle'>
                  Contact client to give access
                </p>
              </div>
            )}
          </div>
          <div className='history-container'>
          <div className="f-500 title">History</div>
            {sessionList?.length > 0 ? (
              <div className="bg-grey border-parent overflow-x-auto hide-scrollbar d-grid">
              {sessionList?.map((historyItem, index) => {
                return (
                  <div className="border-item support-access-history-table p-3 gap-24">
                    <div>
                      {historyItem?.Status === 0
                                ? <span>{moment(historyItem?.StartDate).format("ll")}&nbsp;-&nbsp;</span>
                                : <span>{ moment(historyItem?.StartDate).format("lll")}&nbsp;-&nbsp;{moment(historyItem?.EndDate).format("lll")} </span>  }
                  
                      <span
                                style={{
                                  color: historyItem?.StatusColour,
                                  marginLeft: '4px'
                                }}
                              >
                                {historyItem?.Status_Text}{" "}
                              </span>
                      </div>
                      <div
                            className={`f-400 f-14 pointer ${
                              historyItem?.Status === 0
                                ? "f-danger"
                                : ""
                            } mx-2 line-height-22 letter-space-2`}

                            onClick={()=>{
                              revokeAccess(historyItem?.objId)
                            }}
                          >
                            {historyItem?.Status===0 ?  "Revoke Access"   :""}
                          </div>
                      <div className="d-flex justify-content-end">
                      {historyItem?.SupportPeriodText}
                    </div>
                  </div>
                );
              })}
            </div>
            ) : (
              <div className='no-history-container'>
                <ChipsInformativeIcon width="44p" height="44px" />
                <div className='d-flex flex-column' style={{ marginTop: '16px' }}>
                  <h3 className='m-0 title text-center'>No given access</h3>
                  <h3 className='m-0 subtitle text-center'>There no access records yet</h3>
                </div>
              </div>
            )}
          </div>
        </>
      )}
  </div>
  );
}

export default MspSupportAccess